import { render, staticRenderFns } from "./ClassTraingDetails.vue?vue&type=template&id=64c6c9b0"
import script from "./ClassTraingDetails.vue?vue&type=script&lang=js"
export * from "./ClassTraingDetails.vue?vue&type=script&lang=js"
import style0 from "./ClassTraingDetails.vue?vue&type=style&index=0&id=64c6c9b0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports